import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, createBlock as _createBlock, toDisplayString as _toDisplayString, createStaticVNode as _createStaticVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../assets/star.png'
import _imports_1 from '../assets/heart.png'
import _imports_2 from '../assets/zan.png'
import _imports_3 from '../assets/view.png'
import _imports_4 from '../assets/daren.png'
import _imports_5 from '../assets/play.png'
import _imports_6 from '../assets/collection1.png'


const _withScopeId = n => (_pushScopeId("data-v-ee949ba4"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "home" }
const _hoisted_2 = { class: "banner_item" }
const _hoisted_3 = ["src"]
const _hoisted_4 = { class: "banner_item-cont" }
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "banner_item-p1" }, "Seafood Braised Pasta", -1))
const _hoisted_6 = { class: "banner_item-star" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "3 grade", -1))
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "banner_item-line" }, null, -1))
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { class: "banner_item-p2" }, [
  /*#__PURE__*/_createElementVNode("span", { style: {"display":"inline-block","width":"70%"} }, "Seafood gives pasta a strong flavor, which makes you satisfying"),
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_1,
    style: {"width":"24px","height":"24px"}
  })
], -1))
const _hoisted_10 = { class: "container" }
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", { style: {"margin-top":"0","margin-bottom":"9px"} }, "Popular Suggested", -1))
const _hoisted_12 = { class: "container_popular" }
const _hoisted_13 = ["src"]
const _hoisted_14 = { style: {"display":"flex","align-items":"center"} }
const _hoisted_15 = {
  class: "container_popular-span",
  style: {"padding-right":"16px"}
}
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_2,
  style: {"width":"22px","height":"auto"}
}, null, -1))
const _hoisted_17 = { class: "container_popular-span" }
const _hoisted_18 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_3,
  style: {"width":"22px","height":"auto","margin-right":"4px"}
}, null, -1))
const _hoisted_19 = /*#__PURE__*/_createStaticVNode("<p style=\"margin-bottom:9px;\" data-v-ee949ba4>达人菜谱</p><div class=\"recipe\" data-v-ee949ba4><div class=\"recipe_item\" data-v-ee949ba4><img src=\"" + _imports_4 + "\" style=\"width:100%;\" data-v-ee949ba4><img src=\"" + _imports_5 + "\" style=\"width:48px;\" class=\"recipe_item-player\" data-v-ee949ba4></div><div data-v-ee949ba4>KungPao Chicken</div></div>", 2)
const _hoisted_21 = { style: {"display":"flex","justify-content":"space-between","align-items":"center","margin-bottom":"9px"} }
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "Recipe Collections", -1))
const _hoisted_23 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "banner_item" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_6,
    style: {"width":"100%"}
  }),
  /*#__PURE__*/_createElementVNode("div", { class: "container_collection-cont" }, [
    /*#__PURE__*/_createElementVNode("p", { class: "container_collection-p1" }, "Have Some Nutrition"),
    /*#__PURE__*/_createElementVNode("p", {
      class: "container_collection-p2",
      style: {"color":"#FFF"}
    }, "Eat something nutritious, and greet each new day vitalitly！")
  ])
], -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Search = _resolveComponent("Search")!
  const _component_Menu = _resolveComponent("Menu")!
  const _component_CarouselItem = _resolveComponent("CarouselItem")!
  const _component_Carousel = _resolveComponent("Carousel")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_Search),
    _createVNode(_component_Menu, { list: _ctx.list }, null, 8, ["list"]),
    _createVNode(_component_Carousel, {
      duration: 2000,
      autoplay: false,
      initIndex: 2,
      direction: true,
      directionMode: "hover",
      directionSize: 20,
      directionColor: "skyblue",
      indicator: true,
      indicatorMode: "always",
      indicatorColor: "#595755",
      indicatorActiveColor: "#FFF",
      style: {"height":"481px"},
      class: "banner"
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliders, (item, index) => {
          return (_openBlock(), _createBlock(_component_CarouselItem, {
            key: index,
            idx: index
          }, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_2, [
                _createElementVNode("img", {
                  src: item,
                  style: {"width":"100%"}
                }, null, 8, _hoisted_3),
                _createElementVNode("div", _hoisted_4, [
                  _hoisted_5,
                  _createElementVNode("div", _hoisted_6, [
                    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(3, (i) => {
                      return _createElementVNode("img", {
                        src: _imports_0,
                        key: i
                      })
                    }), 64)),
                    _hoisted_7
                  ]),
                  _hoisted_8,
                  _hoisted_9
                ])
              ])
            ]),
            _: 2
          }, 1032, ["idx"]))
        }), 128))
      ]),
      _: 1
    }),
    _createElementVNode("div", _hoisted_10, [
      _hoisted_11,
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("ul", null, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.popular, (i) => {
            return (_openBlock(), _createElementBlock("li", { key: i }, [
              _createElementVNode("img", {
                src: i.image
              }, null, 8, _hoisted_13),
              _createElementVNode("div", null, _toDisplayString(i.name), 1),
              _createElementVNode("div", _hoisted_14, [
                _createElementVNode("div", _hoisted_15, [
                  _hoisted_16,
                  _createElementVNode("span", null, _toDisplayString(i.zan), 1)
                ]),
                _createElementVNode("div", _hoisted_17, [
                  _hoisted_18,
                  _createElementVNode("span", null, _toDisplayString(i.view), 1)
                ])
              ])
            ]))
          }), 128))
        ])
      ]),
      _hoisted_19,
      _createElementVNode("p", _hoisted_21, [
        _hoisted_22,
        _createElementVNode("span", {
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.goCollection && _ctx.goCollection(...args))),
          class: "title_btn"
        }, "all >")
      ]),
      _createVNode(_component_Carousel, {
        duration: 2000,
        autoplay: false,
        initIndex: 2,
        direction: false,
        directionMode: "hover",
        directionSize: 20,
        directionColor: "skyblue",
        indicator: true,
        indicatorMode: "always",
        indicatorColor: "#C7C7C7",
        indicatorActiveColor: "#595755",
        style: {"height":"418px"},
        class: "container_collection"
      }, {
        default: _withCtx(() => [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.sliders, (item, index) => {
            return (_openBlock(), _createBlock(_component_CarouselItem, {
              key: index,
              idx: index
            }, {
              default: _withCtx(() => [
                _hoisted_23
              ]),
              _: 2
            }, 1032, ["idx"]))
          }), 128))
        ]),
        _: 1
      })
    ])
  ]))
}